<div class="fdx-u-align--left">
  <!--Header and subtitle-->
  <h1 class="fdx-c-header fdx-c-header--h2 fdx-u-mb--4 fdx-u-mt--4" id="login-title">
    {{ 'login.loginSecurityHeader' | translate }}
  </h1>
  <p class="fdx-u-font-size--h7 fdx-u-text--light fdx-u-mb--4" id="login-message">
    <!-- B-775609-Remove mention of 'trusted devices' -->
    <!-- FIXME: please remove the condition once device management goes live -->
    {{(isDecoupleDeviceMgmt ? 'login.loginMessageDeviceDecoupled' : 'login.loginMessage') | translate}}
  </p>

  <hr class="fdx-c-line fdx-c-line--grey--dark-3">
  @if (!editFlag) {
    <div class="fdx-o-grid">
      <div class="fdx-o-grid__row fdx-u-mt--3">
        <div class="fdx-o-grid__item--9">
          <h2 class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--4 fdx-u-mr--2" id="loginSubtitle">
            {{ 'login.subtitle' | translate}}
          </h2>
        </div>
        @if ((isAPIFailLoginScreen || sharedService.isProfileLocked) && !sharedService.isPerformanceExecutorOn()) {
          <wpro-login-call-failure class="fdx-o-grid__item--12" [error]="failureError"
            [messageFlag]="sharedService.isProfileLocked"
            >
          </wpro-login-call-failure>
        }
        @if ((!isAPIFailLoginScreen && !sharedService.isProfileLocked) || sharedService.isPerformanceExecutorOn()) {
          <div class="fdx-o-grid__item--3 fdx-u-align--right fdx-u-mt--2"
            >
            <button (click)="toggleEdit()" id="edit-btn" class="fdx-c-button fdx-c-button--text fdx-u-pr--0"
              aria-live="assertive" aria-atomic="true" attr.aria-label="{{'login.editButton' | translate}}">
              {{'login.editButton' | translate}}
            </button>
          </div>
        }
      </div>
      @if (!isAPIFailLoginScreen && !sharedService.isProfileLocked) {
        <div class="fdx-o-grid__row fdx-u-mb--2">
          <div class="fdx-o-grid__item--3 fdx-o-grid__item--8@small-only fdx-o-grid__item--4@medium-only">
            <label class="fdx-u-font-size--h6 fdx-u-mr--2" id="userId-label">
              {{ 'login.userIdLabel' | translate}}
            </label>
          </div>
          <div class="fdx-o-grid__item--5 fdx-u-mt--1">
            <span class="fdx-u-color--grey--dark-1 grey--dark-1" id="userId-span">
              {{userId}}
            </span>
          </div>
        </div>
      }
      @if (!isAPIFailLoginScreen && !sharedService.isProfileLocked) {
        <div class="fdx-o-grid__row fdx-u-mb--2">
          <div class="fdx-o-grid__item--3 fdx-o-grid__item--8@small-only fdx-o-grid__item--4@medium-only">
            <label class="fdx-u-font-size--h6 fdx-u-mr--2" id="pswd-label">
              {{ 'login.passwordLabel' | translate}}
            </label>
          </div>
          <div class="fdx-o-grid__item--5 fdx-u-mt--1 fdx-u-ml--5@x-small-only">
            <span class="fdx-u-color--grey--dark-1 grey--dark-1">
              *******************
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
@if (editFlag) {
  <div class="fdx-o-grid">
    <form [formGroup]="loginEditForm" aria-live="polite" [attr.aria-busy]="isFormSubmit">
      <div class="fdx-o-grid__row fdx-u-mt--3">
        <div class="fdx-o-grid__item--12">
          <h2 class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--4 fdx-u-mr--2" id="loginSubtitle">
            {{ 'login.subtitle' | translate}}
          </h2>
        </div>
      </div>
      <div class="fdx-o-grid__item--12">
        <h3 id="loginUserID" class="fdx-c-heading fdx-c-heading--h5 fdx-c-heading--bold fdx-u-pb--3">
        {{ 'login.userIdLabel' | translate}}</h3>
      </div>
      @if (!isFdx_user) {
        <div class="fdx-o-grid__item--12">
          <div class="fdx-c-form-group fdx-c-form-group--radio fdx-u-mr--5">
            <input formControlName="emailAsUserId" [value]="false" (change)="changeUserIdType(false)" checked
              type="radio" name="emailAsUserId" id="userIdRadioInput" class="fdx-c-form-group__radio"
              [attr.aria-labelledby]="'userIdRadioLabel'" (focusout)="onFocusOut()">
              <label class="fdx-c-form-group__label" for="userIdRadioInput" id="userIdRadioLabel">{{
              'login.userIdLabel' | translate}}</label>
            </div>
            <div class="fdx-c-form-group fdx-c-form-group--radio">
              <input formControlName="emailAsUserId" [value]="true" (change)="changeUserIdType(true)" type="radio"
                name="emailAsUserId" id="userIdAsEmailRadioInput" class="fdx-c-form-group__radio"
                [attr.aria-labelledby]="'userIdAsEmailRadioLabel'" (focusout)="onFocusOut()">
                <label class="fdx-c-form-group__label" for="userIdAsEmailRadioInput" id="userIdAsEmailRadioLabel">{{
                'login.useEmailAsUserIdLabel' | translate}}</label>
              </div>
            </div>
          }
          <div class="fdx-o-grid__item--12 fdx-u-mt--4">
            <div class="fdx-c-form-group"
              [class.fdx-c-form-group--has-value]="loginEditForm.controls['userId'].value"
              [class.fdx-c-form-group--is-invalid]="(loginEditForm.controls['userId'].errors || loginEditForm.controls['userId'].value === '') && loginEditForm.controls['userId'].dirty">
              <div class="fdx-c-form fdx-c-form--text"
                [class.fdx-c-form--is-invalid]="(loginEditForm.controls['userId'].errors || loginEditForm.controls['userId'].value === '') && loginEditForm.controls['userId'].dirty">
                <input formControlName="userId" type="text" class="fdx-c-form__input" id="userIdTextInput" [maxlength]="maxUserIdLength" value="" aria-describedby="alertID" autocomplete="off" (focusout)="onFocusOut()">
                <label class="fdx-c-form-group__label fdx-c-form__label fdx-u-font-size--button-regular fdx-u-fontweight--bold fdx-u-text--initial" for="userIdTextInput">
                  {{ 'login.userIdLabel' | translate}}
                </label>
                <div class="fdx-c-form__indicator"></div>
              </div>
            </div>
            <!-- showing validation erros on condition -->
            @if (loginEditForm.invalid) {
              <span>
                @if (!showEmailAsUserId &&(loginEditForm.controls['userId'].invalid && (loginEditForm.controls['userId'].errors.required || loginEditForm.controls['userId'].value.length <= 5))) {
                  <div #userIdError role="alert" id="userIdRequiredError"
                    class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0"
                    >
                    <div class="fdx-c-form-message__icon fdx-c-icon">
                      <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                    </div>
                    <span>{{'login.userIdRequired' | translate}}</span>
                  </div>
                }
                @if (loginEditForm.controls['userId'].errors?.specialChar) {
                  <div role="alert" id="specialCharError"
                    class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0">
                    <div class="fdx-c-form-message__icon fdx-c-icon">
                      <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                    </div>
                    {{'login.specialChar' | translate}}
                  </div>
                }
                @if ((showEmailAsUserId && loginEditForm.controls['userId'].dirty && loginEditForm.controls['userId'].errors?.required)) {
                  <div
                    id="emailRequiredError" role="alert" class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0">
                    <div class="fdx-c-form-message__icon fdx-c-icon">
                      <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                    </div>
                    {{'login.emailRequired' | translate}}
                  </div>
                }
                @if ((showEmailAsUserId && loginEditForm.controls['userId'].errors?.emailPattern)) {
                  <div role="alert" id="emailPatternError"
                    class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0">
                    <div class="fdx-c-form-message__icon fdx-c-icon">
                      <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                    </div>
                    {{'login.emailPattern' | translate}}
                  </div>
                }
              </span>
            }
          </div>
          <div class="fdx-o-grid__item--12">
            <div class="fdx-o-grid">
              <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
                <div class="fdx-o-grid__item--12">
                  <h3 id="passwordLabel" class="fdx-c-heading fdx-c-heading--h5 fdx-c-heading--bold fdx-u-pt--6 fdx-u-pb--3">
                    {{'login.passwordLabel' | translate}}
                  </h3>
                </div>
                <div class="fdx-o-grid__item--12">
                  <div class="fdx-c-form-group fdx-u-mt--2"
                    [class.fdx-c-form-group--has-value]="loginEditForm.controls['oldPassword'].value"
                    [class.fdx-c-form-group--is-invalid]="loginEditForm.controls['oldPassword'].errors && (loginEditForm.controls['oldPassword'].dirty || loginEditForm.controls['oldPassword'].touched )">
                    <div class="fdx-c-form fdx-c-form--text fdx-c-form--suffix"
                      [class.fdx-c-form--is-invalid]="loginEditForm.controls['oldPassword'].errors && (loginEditForm.controls['oldPassword'].dirty || loginEditForm.controls['oldPassword'].touched )">
                      <input [type]="isPasswordShow.showoldPassword ? 'text' : 'password'"
                        formControlName="oldPassword" type="password" class="fdx-c-form__input"
                        [minlength]="minPassLengthLegacySix" [maxlength]="maxPassLengthLegacy" id="currentPasswordTextInput"
                        aria-describedby="alertID"
                        [attr.aria-labelledby]="'showHidePasswordLabel'" (input)='onOldPasswordChange()' (focusout)="onFocusOut()">
                        <label class="fdx-c-form-group__label fdx-c-form__label fdx-u-font-size--button-regular fdx-u-fontweight--bold fdx-u-text--initial"
                          id="showHidePasswordLabel"
                        for="currentPasswordTextInput">{{'login.currentPasswordLabel' | translate}}</label>
                        <!-- hide and show button -->
                        <div class="fdx-c-form__indicator"></div>
                        <div class="fdx-c-form__suffix">
                          <button id="hideShow-btn"
                            class="fdx-c-button fdx-c-form__button fdx-c-button--text fdx-c-form__button--outline"
                            aria-atomic="true"
                            aria-live="assertive"
                            (click)="hideShowPass('showoldPassword')">
                            <ciam-icon [key]="!isPasswordShow.showoldPassword ? 'utility_hide' : 'utility_show'"
                              class="fdx-c-form__suffix__toggle-label__icon"
                              color="#007ab7">
                            </ciam-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- showing validation erros on condition -->
                    @if (loginEditForm.invalid) {
                      <span>
                        @if (loginEditForm.controls['oldPassword'].invalid && (loginEditForm.controls['oldPassword'].dirty || loginEditForm.controls['oldPassword'].touched) && loginEditForm.controls['oldPassword'].errors) {
                          <div #oldPasswordError role="alert" id="oldPasswordRequiredError"
                            class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0"
                            >
                            <div class="fdx-c-form-message__icon fdx-c-icon">
                              <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                            </div>
                            @if (loginEditForm.controls['oldPassword'].errors.required) {
                              <span>
                              {{'login.currentPasswordRequired' | translate}}</span>
                            }
                            @if (loginEditForm.controls['oldPassword'].errors.minlength) {
                              <span>
                              {{ minPassLengthLegacy | translate }}</span>
                            }
                          </div>
                        }
                      </span>
                    }
                  </div>
                  <div class="fdx-o-grid__item--12">
                    <div class="fdx-c-form-group fdx-u-mt--2"
                      [class.fdx-c-form-group--has-value]="hasInputValue()"
                      [class.fdx-c-form-group--is-invalid]="isNewPasswordInvalid()">
                      <div class="fdx-c-form fdx-c-form--text fdx-c-form--suffix"
                        [class.fdx-c-form--is-invalid]="isNewPasswordInvalid()">
                        <input [type]="isPasswordShow.showNewPassword ? 'text' : 'password'" formControlName="newPassword" type="password" [minlength]="minPassLengthTwelve" [maxlength]="maxPassLength" id="newPasswordTextInput" aria-describedby="alertID" (focusout)="onFocusOut(); onNewPasswordInteraction()" (focusin)="onNewPasswordInteraction()" class="fdx-c-form__input" value="">
                        <label class="fdx-c-form-group__label fdx-c-form__label fdx-u-font-size--button-regular fdx-u-fontweight--bold fdx-u-text--initial" for="newPasswordTextInput">
                          {{ 'login.newPasswordLabel' | translate}}
                        </label>
                        <div class="fdx-c-form__indicator"></div>
                        <div class="fdx-c-form__suffix">
                          <button id="hideShow-btn" class="fdx-c-button fdx-c-form__button fdx-c-button--text fdx-c-form__button--outline" aria-atomic="true" aria-live="assertive" (click)="hideShowPass('showNewPassword')">
                            <ciam-icon [key]="!isPasswordShow.showNewPassword ? 'utility_hide' : 'utility_show'" class="fdx-c-form__suffix__toggle-label__icon" color="#007ab7">
                            </ciam-icon>
                          </button>
                        </div>
                        @if (hasInteractedWithNewPassword || isNewPasswordInvalid()) {
                          <div class="fdx-c-form__message fdx-u-width--50@medium-wide">
                            <div class="fdx-c-form__message__item fdx-u-mb--2">
                              {{ 'login.passwordReqTitle' | translate}}
                            </div>
                            <span class="fdx-c-form__message__item" id="minCharError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordError('length')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordError('length') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('length', false)">
                              </ciam-icon>
                              {{ minMaxPassRuleMsg }}
                            </span>
                            <span class="fdx-c-form__message__item" id="oneNumberError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordError('oneNumber')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordError('oneNumber') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('oneNumber', false)">
                              </ciam-icon>
                              {{ 'login.oneNumberNew' | translate}}
                            </span>
                            <span class="fdx-c-form__message__item" id="upperAndLowerError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordError('upperAndLowerChar')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordError('upperAndLowerChar') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('upperAndLowerChar', false)">
                              </ciam-icon>
                              {{ 'login.oneUpperLowerCase' | translate}}
                            </span>
                            <span class="fdx-c-form__message__item" id="consecutiveCharError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordSpError('consecutiveChars')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordSpError('consecutiveChars') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('consecutiveChars', true)">
                              </ciam-icon>
                              {{ 'login.noConsecutiveChars' | translate}}
                            </span>
                            <span class="fdx-c-form__message__item" id="specialCharError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordSpError('specialChar')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordSpError('specialChar') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('specialChar', true)">
                              </ciam-icon>
                              {{ 'login.noSpacesOrSpecialChars' | translate}}
                            </span>
                            <span class="fdx-c-form__message__item" id="userInfoError"
                              [class.fdx-c-form__message__item--error]="hasNewPasswordSpError('userInfo')"
                              [class.fdx-c-form__message__item--success]="(!hasNewPasswordSpError('userInfo') && hasInputValue())">
                              <ciam-icon class="fdx-c-icon fdx-c-form__message__item__icon" aria-hidden="true" focusable="false" role="presentation" color="008a00" [key]="getIconKey('userInfo', true)">
                              </ciam-icon>
                              {{ 'login.noPersonalInfo' | translate}}
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                    <!-- showing validation erros on condition -->
                    @if (!hasInteractedWithNewPassword) {
                      <span>
                        @if (loginEditForm.controls['newPassword'].invalid && isNewPasswordInvalid()) {
                          <div #newPasswordError role="alert" id="newPasswordRequiredError" class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0">
                            @if (loginEditForm.controls['newPassword'].errors.required) {
                              <div
                                class="fdx-c-form-message__icon fdx-c-icon">
                                <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                              </div>
                            }
                            @if (loginEditForm.controls['newPassword'].errors.required) {
                              {{'login.newPasswordRequired' | translate}}
                            }
                          </div>
                        }
                      </span>
                    }
                  </div>
                  <div class="fdx-o-grid__item--12">
                    <div class="fdx-c-form-group fdx-u-mt--2"
                      [class.fdx-c-form-group--has-value]="loginEditForm.controls['reTypePassword'].value"
                      [class.fdx-c-form-group--is-invalid]="loginEditForm.controls['reTypePassword'].errors && (loginEditForm.controls['reTypePassword'].dirty || loginEditForm.controls['reTypePassword'].touched)">
                      <div class="fdx-c-form fdx-c-form--text fdx-c-form--suffix"
                        [class.fdx-c-form--is-invalid]="loginEditForm.controls['reTypePassword'].errors && (loginEditForm.controls['reTypePassword'].dirty || loginEditForm.controls['reTypePassword'].touched)">
                        <input [type]="isPasswordShow.showReTypePassword ? 'text' : 'password'"
                          formControlName="reTypePassword" type="password" class="fdx-c-form__input"
                          id="confirmPasswordTextInput" value="" [minlength]="minPassLengthTwelve" [maxlength]="maxPassLength"
                          aria-describedby="alertID"
                          required (focusout)="onFocusOut()">
                          <label class="fdx-c-form-group__label fdx-c-form__label fdx-u-font-size--button-regular fdx-u-fontweight--bold fdx-u-text--initial"
                          for="confirmPasswordTextInput">{{'login.reEnterPasswordLabel' | translate}}</label>
                          <!-- hide and show button -->
                          <div class="fdx-c-form__indicator"></div>
                          <div class="fdx-c-form__suffix">
                            <button id="hideShow-btn"
                              class="fdx-c-button fdx-c-form__button fdx-c-button--text fdx-c-form__button--outline"
                              aria-atomic="true"
                              aria-live="assertive"
                              (click)="hideShowPass('showReTypePassword')">
                              <ciam-icon [key]="!isPasswordShow.showReTypePassword ? 'utility_hide' : 'utility_show'"
                                class="fdx-c-form__suffix__toggle-label__icon"
                                color="#007ab7">
                              </ciam-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                      @if (loginEditForm.invalid) {
                        <span>
                          @if (loginEditForm.controls['reTypePassword'].invalid && (loginEditForm.controls['reTypePassword'].dirty || loginEditForm.controls['reTypePassword'].touched) && loginEditForm.controls['reTypePassword'].errors) {
                            <div #reTypePasswordRequired role="alert" id="reTypePasswordRequiredError"
                              class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0"
                              >
                              @if (loginEditForm.controls['reTypePassword'].errors.required) {
                                <div class="fdx-c-form-message__icon fdx-c-icon"
                                  >
                                  <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                                </div>
                              }
                              @if (loginEditForm.controls['reTypePassword'].errors.required) {
                                <span>
                                {{'login.reEnterPasswordRequired' | translate}}</span>
                              }
                            </div>
                          }
                        </span>
                      }
                      @if (loginEditForm.controls['reTypePassword'].errors?.passMatch) {
                        <span>
                          <div role="alert" #reTypePasswordMismatchError
                            class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0">
                            <div class="fdx-c-form-message__icon fdx-c-icon">
                              <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                            </div>
                            <span>{{'login.retypePasswordNotMatch' | translate}}</span>
                          </div>
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <!--passwordValidation from API-->
              @if (errorCode && !valueChanged) {
                <span>
                  <div class="fdx-u-mb--3 fdx-u-align--left fdx-u-mb--1 fdx-u-mr--3@large">
                    <div role="alert" id="invalidCredentials"
                      class="fdx-c-form-message fdx-u-flex-align-items--start fdx-c-form-message--error fdx-u-pl--0 fdx-u-pb--0 fdx-o-grid__item--12@small-only">
                      <div class="fdx-c-form-message__icon fdx-c-icon">
                        <ciam-icon aria-hidden="true" key="utility_cross-fat"></ciam-icon>
                      </div>
                      <span>
                        {{ errorCode }}
                      </span>
                    </div>
                  </div>
                </span>
              }
              <div class="fdx-o-grid__item--12 fdx-u-align--center fdx-u-mt--5">
                <button (click)="onLoginFormSubmit()" id="saveChangesBtn"
                  class="fdx-c-button fdx-c-button--primary fdx-c-button--loading fdx-c-button--responsive"
                  [ngClass]="{'fdx-c-button--is-loading' : isFormSubmit}" [disabled]="isFormSubmit"
                  aria-atomic="true" aria-live="assertive" aria-label="{{ 'login.saveChangesBtnLabel' | translate}}">
                  <span class="fdx-c-button__loading-container">
                    <span class="fdx-c-button__title">{{ 'login.saveChangesBtnLabel' | translate}}</span>
                    <span class="fdx-c-button__loading">
                      <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                      </div>
                    </span>
                  </span>
                </button>
              </div>
              <div class="fdx-o-grid__item--12 fdx-u-align--center">
                <button id="cancelBtn" (click)="toggleEditState()" attr.aria-label="{{'login.cancelLabel' | translate}}"
                  class="fdx-c-button fdx-c-button--text fdx-u-mb--7 fdx-u-cursor--pointer">
                  {{'login.cancelLabel' | translate}}
                </button>
              </div>
            </form>
          </div>
        }
        <hr class="fdx-c-line fdx-c-line--grey--dark-3  fdx-u-mb--2">

        @if (isAdaptiveMfa) {
          <wpro-adaptive-mfa [hidden]="isFdx_user" (hideNotificationPopup)="hideNotificationPopup($event)" [twosvFlag]="twosv" (hideDefaultverifyandTrustedDevice)="hideDefaultverifyandTrustedDevice($event)"
          (hideSuccessNotificationPopup)="hideSuccessNotificationPopup($event,'')" (continueVerifyFlow)="continueVerifyFlow($event)" (closeLoginEdit)=closeLoginEdit($event)>
          </wpro-adaptive-mfa>
        } @else {
          <wpro-two-stepverification [hidden]="isFdx_user" (hideNotificationPopup)="hideNotificationPopup($event)" [twosvFlag]="twosv" (hideDefaultverifyandTrustedDevice)="hideDefaultverifyandTrustedDevice($event)"
          (hideSuccessNotificationPopup)="hideSuccessNotificationPopup($event,'')" (continueVerifyFlow)="continueVerifyFlow($event)" (closeLoginEdit)=closeLoginEdit($event)>
          </wpro-two-stepverification>
          
          <!-- FIXME: please remove the condition once device management goes live -->
          <!-- <wpro-devices *ngIf="!isDecoupleDeviceMgmt" (closeLoginEditScreen)= closeLoginEdit($event)></wpro-devices> -->
  
          @if (!isFdx_user && isTwoFAEnabled) {
            <div>
              @if (!isAdaptiveMfa) {
                <hr>
                <wpro-trusted-device></wpro-trusted-device>
              }
            </div>
          }
        }
        <!--{{messageFlag}} -->
        @if (toastFlag) {
          <wpro-success-notification [messageFlag]="messageFlag"
            (hideSuccessNotificationPopup)="hideSuccessNotificationPopup($event, '')">
          </wpro-success-notification>
        }
        @if (errorFlag) {
          <wpro-error-notification [errorInfo]="errorInfo" [messageFlag]="messageFlag"
            [errorNotificationBoolean]="errorNotificationBoolean" (hideNotificationPopup)="hideNotificationPopup($event)">
          </wpro-error-notification>
        }

          <ng-template #twoFactorElevationFailure>
            <p>{{'contact.twoFactorElevationError' | translate}}</p>
          </ng-template>

          <!-- Profile Edit: Listens for email ID change event from login security form submit -->
          <wpro-profile-edit (returnToView)="closeLoginEdit(false)"></wpro-profile-edit>
